import { Switch, Route } from "wouter";
import { Suspense, lazy } from "react";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const Home = lazy(() => import("@/pages/Home"));
const Shop = lazy(() => import("@/pages/Shop"));
const Login = lazy(() => import("@/pages/Login"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Admin = lazy(() => import("@/pages/Admin"));
const Cart = lazy(() => import("@/pages/Cart"));
const Orders = lazy(() => import("@/pages/Orders"));
const AddProduct = lazy(() => import("@/pages/admin/AddProduct"));
const VyaparSync = lazy(() => import("@/pages/admin/VyaparSync"));
const ProductManagement = lazy(() => import("@/pages/admin/ProductManagement"));
const ChangePin = lazy(() => import("@/pages/ChangePin"));
const DataImport = lazy(() => import("@/pages/admin/DataImport"));
const MobileVerification = lazy(() => import("@/pages/admin/MobileVerification"));
const BulkOrders = lazy(() => import("@/pages/BulkOrders"));
const NotFound = lazy(() => import("@/pages/not-found"));

function Router() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="animate-pulse h-10 w-10 rounded-full bg-muted" />
        </div>
      }
    >
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/bulk-orders" component={BulkOrders} />
        <Route path="/shop" component={Shop} />
        <Route path="/login" component={Login} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/cart" component={Cart} />
        <Route path="/orders" component={Orders} />
        <Route path="/admin" component={Admin} />
        <Route path="/admin/add-product" component={AddProduct} />
        <Route path="/admin/products" component={ProductManagement} />
        <Route path="/admin/vyapar-sync" component={VyaparSync} />
        <Route path="/admin/data-import" component={DataImport} />
        <Route path="/admin/mobile-verification" component={MobileVerification} />
        <Route path="/change-pin" component={ChangePin} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <div className="min-h-screen bg-background font-sans antialiased">
              <Router />
              <Toaster />
            </div>
          </TooltipProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
